import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {PractitionerCareTeamInput} from "../domain";
import {SelectOption} from "common";
import {ProviderPersonLookupMultipleInput} from "../../notification/ProviderPersonLookupMultipleInput";

type CareTeamRoleInputProps = {
    practitioners: SelectOption[],
    setPractitioners: (options: SelectOption[]) => void;
    sending: boolean;
};
export const PractitionerCareTeamClinicianInput = memo(({
                                                            sending,
                                                            practitioners,
                                                            setPractitioners
                                                        }: CareTeamRoleInputProps) => {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<PractitionerCareTeamInput>();


    return (
        <div>
            <div className="flex text-black-200 pb-2 items-center text-base">
                <div className="w-2/6 text-right">
                    Practitioner
                </div>
                <div className="w-3/6 ml-4 flex items-center">
                    <Controller
                        name="clinicianGuid"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={() =>
                            <ProviderPersonLookupMultipleInput
                                fieldValues={practitioners}
                                disabled={sending}
                                setFieldValues={(values) => {
                                    setPractitioners(values)
                                    setValue("clinicianGuid", (values && values.length > 0) ? values[0].value : "");

                                    if (values.length > 0) {
                                        clearErrors("clinicianGuid");
                                    }
                                }}
                                maxSelectNum={1}
                                personLookupType={'ProviderUser'}
                            />
                        }/>
                </div>
            </div>
            {
                errors.clinicianGuid &&
                <div className="flex">
                    <div className="w-2/6"/>
                    <div className="ml-4 text-red-700">
                        Please select a “Practitioner” before submitting the care team
                    </div>
                </div>
            }
        </div>
    );
});
